import { render } from "./Company.vue?vue&type=template&id=058a34f2"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
script.render = render

export default script